import { render, staticRenderFns } from "./WpRichText.vue?vue&type=template&id=d86bb0a2&"
import script from "./WpRichText.vue?vue&type=script&lang=js&"
export * from "./WpRichText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports